import styled from 'styled-components';
import { media } from 'helpers/breakpoints';
import { Variants } from 'components/Toolkit/InfoTitle/InfoTitle';

interface ITitle {
  shouldTruncate: boolean;
  largeTruncationWidth?: number;
  smallTruncationWidth?: number;
  variant: Variants;
  flip: boolean;
  disabled?: boolean;
}

const Title = styled.p<ITitle>`
  ${({ theme, variant }) =>
    variant === 'SMALL'
      ? theme.fontSize.M16
      : variant === 'XS'
      ? theme.fontSize.B12
      : theme.fontSize.L18};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  ${({ variant, theme }) =>
    variant === 'XS' && `color: ${theme.colors.GREY_DARKER}`};
  color: ${({ disabled, theme }) =>
    disabled ? theme.colors.GREY : theme.colors.GREY_DARKER};

  ${({ shouldTruncate, smallTruncationWidth }) =>
    shouldTruncate &&
    `white-space: nowrap;
      overflow: hidden;
      max-width: ${smallTruncationWidth ? smallTruncationWidth : 230}px;
      text-overflow: ellipsis;`};

  ${media.large} {
    ${({ largeTruncationWidth }) =>
      largeTruncationWidth && `max-width: ${largeTruncationWidth}px;`};
    ${({ theme, variant }) => variant === 'XS' && theme.fontSize.L18};
  }
  ${({ flip }) => (flip ? 'order: 2;' : '')};
`;

export { Title };
